<template>
  <h1 class="text-center">Animations</h1>
</template>

<script>
export default {
  name: "Animations"
}
</script>

<style scoped>

</style>